<template xmlns:v-swiper="http://www.w3.org/1999/xhtml">
  <div class="warpper-home">
    <template v-if="(isMobileFlg && !isLogin) || !isMobileFlg">
      <div
        class="swiper-container"
        :class="{ swiperNoLogin: isMobileFlg && !isLogin }"
        v-swiper:mySwiper="swiperOption"
      >
        <div class="swiper-wrapper">
          <div v-if="s1 != null" class="swiper-slide">
            <img :src="s1" alt="/" />
          </div>
          <div v-if="s2 != null" class="swiper-slide">
            <img :src="s2" alt="/" />
          </div>
          <div v-if="s3 != null" class="swiper-slide">
            <img :src="s3" alt="/" />
          </div>
          <div v-if="s4 != null" class="swiper-slide">
            <img :src="s4" alt="/" />
          </div>
          <div v-if="s5 != null" class="swiper-slide">
            <img :src="s5" alt="/" />
          </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        <!-- <div class="swiper_bottom_shade" :class="{activemobile: isMobileFlg && !isLogin}"></div> -->
      </div>
    </template>
    <!-- selfCourse -->
    <selfCourse v-if="loginName == null || checkLoginNameIsEmail(loginName)"></selfCourse>
    <!-- message -->
    <message />
    <!-- catalogHeader v-if="checkGeneralEnvironmentIndex==4&&!checkGeneralEnvironmentDongDuIndex" -->
    <!-- <template v-if="checkGeneralEnvironmentIndex==4&&!checkGeneralEnvironmentDongDuIndex"> -->
    <!-- <catalogHeader v-if="loadDataCatalog" :dataCatatalog="{dataListCatalog: dataListCatalog}"></catalogHeader> -->
    <!-- </template> -->
    <!-- Hiển thị trang bán khoá học -->
    <!-- <template v-if="checkGeneralEnvironmentIndex==4&&!checkGeneralEnvironmentDongDuIndex"> -->
    <!-- <topIndexDefineSellCourse v-if="loadDataCatalog" :dataCatatalog="{dataListCatalog: dataListCatalog}"></topIndexDefineSellCourse> -->
    <!-- </template> -->
    <!-- <div class="bigCourse" :class="[{ boxout: isMobileFlg }, { 'primarymenu-add': arrowdownCss }]" ref="heightOut">
            <ul class="clear mg-cl-t" :class="{ boxin: isMobileFlg }" ref="heightIn">
                <li v-for="item in menuList" :key="item.id">
                    <a :href="'#lessons_' + item.id" @click="cssedit">{{ item.name }}</a>
                </li>
            </ul>
            <p class="showAllCourse" v-show="arrowdownIcon" @click="cssedit">
                <i v-if="this.arrowdownCss" class="el-icon-arrow-down down_laa" @mouseover="mouseOverDown($event)" @mouseleave="mouseLeaveDown($event)"></i>
                <i v-if="!this.arrowdownCss" class="el-icon-arrow-up up_laa" @mouseover="mouseOverUp($event)" @mouseleave="mouseLeaveUp($event)"></i>
            </p>
        </div> -->

    <div class="primarylists nqt__priList">
      <ul class="container">
        <!-- Khoá học nổi bật -->
        <li v-if="dataImportantCourses.length > 0">
          <div class="titles clear">
            <img src="../../../static/images/icon-st.jpg" alt="" />
            <div class="title l">
              <span style="text-transform: uppercase!important;"
                >{{ $t("new.title220") }}
              </span>
              <span
                v-if="!isMobileFlg"
                class="title_more_catalog"
                @click="goRouter('/home/moreCourses')"
              >
                <span class="name_more_catalog">{{ $t("new.title3") }}</span>
                <span
                  ><img
                    class="icon_more_catalog"
                    style="height: auto!important;width: 17px!important;cursor: pointer;"
                    src="../../../static/images/dbright.png"
                    alt=""
                /></span>
              </span>
            </div>
          </div>
          <div class="lessons lessons-new">
            <ul class="clear">
              <li
                v-for="(item, index) in dataImportantCourses"
                :key="index"
                @click="go_course(item, 1)"
                :class="{
                  disabledCourse: checkedStatus ? index > 3 : index > 9
                }"
              >
                <div v-if="!item.isUrl">
                  <div class="img vaa">
                    <img
                      v-if="
                        item.courseCover == undefined ||
                          item.courseCover == null ||
                          item.courseCover == ''
                      "
                      src="../../../static/images/temppic.jpg"
                      alt="/"
                    />
                    <img
                      v-else-if="item.courseCover.endsWith('/file/')"
                      src="../../../static/images/temppic.jpg"
                      alt="/"
                    />
                    <img v-else :src="item.courseCover" alt="/" />
                  </div>
                  <div
                    class="lessontitle lessontitle-under"
                    style="height: auto !important;"
                  >
                    {{ item.courseName }}
                  </div>
                  <!-- <div class="introduce" v-html="item.synopsis"></div> -->
                  <div class="like-ps">
                    <div class="islike">
                      <div>
                        <img
                          src="../../../static/images/heart_icon.png"
                          style="cursor: pointer; height: 15px; display: inline-block;"
                        />
                        <span> {{ item.likeNum }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div class="img vaa">
                    <span v-html="item.courseCover"></span>
                  </div>
                  <div class="lessontitle ">{{ item.courseName }}</div>
                  <div class="like-ps">
                    <div class="islike">
                      <div>
                        <img
                          src="../../../static/images/heart_icon.png"
                          style="cursor: pointer; height: 15px; display: inline-block;"
                        />
                        <span> {{ item.likeNum }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div
            v-if="isMobileFlg"
            class="more l"
            @click="goRouter('/home/moreCourses')"
          >
            <a>{{ $t("new.title3") }}</a>
          </div>
        </li>
      </ul>
    </div>
    <!-- Hiển thị trang bán khoá học  -->
    <!-- </template> -->
    <div class="footer">
      <p class="line1">&nbsp;</p>
      <p class="line2">&nbsp;</p>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Element from "element-ui";
import Vue from "vue";
import { mapMutations } from "vuex";
import { lang } from "../../assets/languages/getLanguageType.js";
Vue.prototype.$lang = lang;
import topIndexDefineSellCourse from "@/components/defineSelfCourse/topIndex";
import catalogHeader from "@/components/defineSelfCourse/catalogHeader";
import selfCourse from "@/views/defineSelfCourse/selfIndexCourse";
import message from "@/components/message/message";
export default {
  activeName: "second",
  name: "index",
  components: {
    Swiper,
    SwiperSlide,
    topIndexDefineSellCourse,
    catalogHeader,
    selfCourse,
    message
  },
  directives: {
    swiper: directive
  },
  props: ["userId"],
  data() {
    return {
      userIds: null,
      checkBanner: false,
      s1: null,
      s2: null,
      s3: null,
      s4: null,
      s5: null,
      sArrays: [],
      sList: null,
      isMobileFlg: false,
      arrowdownCss: true,
      arrowdownIcon: true,
      heightOut: 0,
      heightIn: 0,
      courseInfo: {},
      currentIndex1: -1,
      currentIndex2: -1,
      tagOne: null,
      tagTwo: null,
      loading: false,
      listItems: [],
      listLikeCourse: [],
      listItemCourses: [],
      menuList: null,
      recommendCourse: {},
      itemList: [],
      dataImportantCourses: [],
      swiperOption: {
        centeredSlides: true,
        slidesPerView: 1,
        initialSlide: 2,
        loop: true,
        spaceBetween: 0,
        paginationClickable: true,
        breakpoints: {
          1112: {
            slidesPerView: 1,
            initialSlide: 1,
            centeredSlides: true,
            speed: 600,
            loop: true,
            spaceBetween: 20
          }
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        initialSlide: 1,
        mousewheel: true
      },
      checkedStatus: false,
      isLogin: false,
      loginName: null,
      regex: new RegExp(/^\[LiveStream\]\r\n(http:\/\/|https:\/\/).*$/),
      dataListCatalog: {},
      showDataCatalog: true,
      loadDataCatalog: false,
      checkGeneralEnvironmentIndex: 0,
      checkGeneralEnvironmentDongDuIndex: true,
      languageDefault: 0
    };
  },
  created() {
    this.checkGeneralEnvironmentIndex = this.checkGeneralEnvironment();
    this.checkGeneralEnvironmentDongDuIndex = this.checkGeneralEnvironmentDongDu();
    window.addEventListener("resize", this.getMenuHeight);
    if (this._isMobile()) {
      this.checkedStatus = true;
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getMenuHeight);
  },
  mounted() {
    this.languageDefault = this.$lang();
    // Get Important Course
    this.$api
      .post("/home/getImportantCourses", {
        languageType: this.$lang()
      })
      .then(response => {
        this.dataImportantCourses = response.data;
        // this.dataImportantCourses.forEach(element => {
        //     if (element.courseCover) {
        //         fetch(element.courseCover)
        //         .then(res => res.blob())
        //         .then(blob => {
        //             let objectURL = URL.createObjectURL(blob);
        //             element.courseCover = objectURL;
        //         });
        //     }
        // });
      });
    /// check token
    let token = window.document.cookie.match("(^|;) ?token-dongdu=([^;]*)(;|$)");
    token = token ? token[2] : null;
    let checkLoginLocal = window.sessionStorage.getItem("id");
    if (checkLoginLocal && token) {
      this.isLogin = true;
    } else {
      this.isLogin = false;
    }
    setTimeout(() => {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    }, 2000);

    this.userIds = window.sessionStorage.getItem("id");
    this.loginName = window.sessionStorage.getItem("loginName");
    this.getMenuHeight();
    this.companyId = window.sessionStorage.getItem("companyId");
    let bannerLogin = this.isLogin ? 1 : 0;
    this.checkBanner = window.sessionStorage.getItem(
      "checkBanner_" + this.languageDefault + bannerLogin
    )
      ? true
      : false;
    if (this.checkBanner) {
      var listBanner = JSON.parse(
        window.sessionStorage.getItem(
          "banner_" + this.languageDefault + bannerLogin
        )
      );
      for (var k = 0; k < listBanner.length; k++) {
        if (k == 0) {
          fetch(listBanner[k].imagePath)
            .then(res => res.blob())
            .then(blob => {
              let objectURL = URL.createObjectURL(blob);
              this.s1 = objectURL;
            });
        }
        if (k == 1) {
          fetch(listBanner[k].imagePath)
            .then(res => res.blob())
            .then(blob => {
              let objectURL = URL.createObjectURL(blob);
              this.s2 = objectURL;
            });
        }
        if (k == 2) {
          fetch(listBanner[k].imagePath)
            .then(res => res.blob())
            .then(blob => {
              let objectURL = URL.createObjectURL(blob);
              this.s3 = objectURL;
            });
        }
        if (k == 3) {
          fetch(listBanner[k].imagePath)
            .then(res => res.blob())
            .then(blob => {
              let objectURL = URL.createObjectURL(blob);
              this.s4 = objectURL;
            });
        }
        if (k == 4) {
          fetch(listBanner[k].imagePath)
            .then(res => res.blob())
            .then(blob => {
              let objectURL = URL.createObjectURL(blob);
              this.s5 = objectURL;
            });
        }
      }
    } else {
      this.loading = true;
      this.$api
        .post("/home/getHomeCourseInfo", {
          languageType: this.$lang(),
          companyId: this.companyId,
          domainName: window.location.host
        })
        .then(response => {
          this.courseInfo = response.data;
          this.recommendCourse = this.courseInfo.starCourse.courseList;
          this.listLikeCourse = this.courseInfo.featuredCourse.courseList;
          this.checkIsUrlForCategory(response.data);
          let items = [];
          if (this.checkedStatus) {
            Promise.resolve(this.recommendCourse).then(function(data) {
              if (data.length > 4) {
                for (let index = 0; index < 4; index++) {
                  items.push(data[index]);
                }
              } else {
                for (let index = 0; index < data.length; index++) {
                  items.push(data[index]);
                }
              }
            });
          } else {
            Promise.resolve(this.recommendCourse).then(function(data) {
              for (let index = 0; index < data.length; index++) {
                items.push(data[index]);
              }
            });
          }
          this.listItems = items;

          this.checkIsUrl(items);

          this.menuList = this.courseInfo.starCourse.menuList;
          var version = Math.random();
          this.sList = this.courseInfo.frontList;
          let v = Math.floor(Math.random() * 10);
          if (this.sList != null) {
            window.sessionStorage.setItem(
              "checkBanner_" + this.languageDefault + bannerLogin,
              true
            );
            window.sessionStorage.setItem(
              "banner_" + this.languageDefault + bannerLogin,
              JSON.stringify(this.sList)
            );
            for (var k = 0; k < this.sList.length; k++) {
              if (k == 0) {
                fetch(this.sList[k].imagePath + "?v=" + v)
                  .then(res => res.blob())
                  .then(blob => {
                    let objectURL = URL.createObjectURL(blob);
                    this.s1 = objectURL;
                  });
              }
              if (k == 1) {
                fetch(this.sList[k].imagePath + "?v=" + v)
                  .then(res => res.blob())
                  .then(blob => {
                    let objectURL = URL.createObjectURL(blob);
                    this.s2 = objectURL;
                  });
              }
              if (k == 2) {
                fetch(this.sList[k].imagePath + "?v=" + v)
                  .then(res => res.blob())
                  .then(blob => {
                    let objectURL = URL.createObjectURL(blob);
                    this.s3 = objectURL;
                  });
              }
              if (k == 3) {
                fetch(this.sList[k].imagePath + "?v=" + v)
                  .then(res => res.blob())
                  .then(blob => {
                    let objectURL = URL.createObjectURL(blob);
                    this.s4 = objectURL;
                  });
              }
              if (k == 4) {
                fetch(this.sList[k].imagePath + "?v=" + v)
                  .then(res => res.blob())
                  .then(blob => {
                    let objectURL = URL.createObjectURL(blob);
                    this.s5 = objectURL;
                  });
              }
            }
          } else {
            this.s1 = "/static/images/s1.jpg";
            this.s2 = "/static/images/s2.jpg";
            this.s3 = "/static/images/s3.jpg";
            this.s4 = "/static/images/s4.jpg";
            this.s5 = "/static/images/s5.jpg";
          }
          this.loading = false;
        });
    }
    if (this._isMobile()) {
      this.isMobileFlg = true;
      this.arrowdownIcon = false;
    } else {
      this.isMobileFlg = false;
    }
  },
  methods: {
    checkIsUrl(val) {
      const self = this;
      Promise.resolve(val).then(function(data) {
        for (let index = 0; index < data.length; index++) {
          if (self.regex.test(data[index].synopsis)) {
            data[index]["isUrl"] = true;
            let url = data[index].synopsis.split("\r\n");
            data[index].courseCover =
              "<iframe width='100% !important' height='100% !important' src='" +
              url[1] +
              "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>";
          } else {
            data[index]["isUrl"] = false;
          }
        }
        self.listItems = data;
      });
    },
    checkIsUrlForCategory(val) {
      val.courses.forEach(item => {
        item.courseList.forEach(el => {
          if (this.regex.test(el.synopsis)) {
            el["isUrl"] = true;
            let url = el.synopsis.split("\r\n");
            el.courseCover =
              "<iframe width='100% !important' height='100% !important' src='" +
              url[1] +
              "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>";
          } else {
            el["isUrl"] = false;
          }
        });
      });
      this.courseInfo = val;
    },
    getMenuHeight() {
      const that = this;
      if (that.$refs.heightOut != undefined) {
        that.heightOut = that.$refs.heightOut.offsetHeight;
        that.heightIn = that.$refs.heightIn.offsetHeight;
        if (that.heightOut < that.heightIn) {
          that.arrowdownIcon = true;
        } else {
          that.arrowdownIcon = false;
        }
      }
    },
    cssedit() {
      this.arrowdownCss = !this.arrowdownCss;
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },

    handleClick(el, a, b) {},
    explore: function() {
      let jump = document.querySelectorAll("#explore");
      let total = jump[0].offsetTop;
      let distance = document.getElementById("app").scrollTop;
      let step = total / 50;
      if (total > distance) {
        smoothDown();
      } else {
        let newTotal = distance - total;
        step = newTotal / 50;
        smoothUp();
      }

      function smoothDown() {
        if (distance < total) {
          distance += step;
          document.getElementById("app").scrollTop = distance;
          setTimeout(smoothDown, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }

      function smoothUp() {
        if (distance > total) {
          distance -= step;
          document.getElementById("app").scrollTopp = distance;
          setTimeout(smoothUp, 10);
        } else {
          document.getElementById("app").scrollTop = total;
        }
      }
    },
    go_regist: function() {
      this.$emit("info", "regist");
    },
    goRouter: function(url, tagOneId) {
      if (tagOneId) {
        this.$router.push({
          path: url,
          query: {
            tagOne: tagOneId
          }
        });
      } else {
        this.$router.push(url);
      }
    },
    begin_start: function() {},
    ...mapMutations("header", ["setHistory"]),
    go_course: function(item, collegeId) {
      window.sessionStorage.setItem("courseGOBackNum", 1);
      this.setHistory("/home");
      let arrCourse = {
        idPage: item.courseId,
        listCourseHome: this.recommendCourse
      };
      window.sessionStorage.setItem("arrCourse", JSON.stringify(arrCourse));
      // this.$router.push({
      //     name: "Aicourse",
      //     query: {
      //         buyCourseId: item.courseId,
      //         buyCollegeId: collegeId,
      //     },
      // });
      //-----------------■コースセット対応--------------------------------------
      this.$api
        .post("/coursesPurchase/isScheduleCourse", {
          courseId: item.courseId
        })
        .then(response => {
          let isScheduleCourseFlag = response.data;
          if (isScheduleCourseFlag == 1) {
            this.$message.warning(window.vm.$i18n.t("new.title192"));
            return;
          } else {
            // Đi đến chi tiết khóa học
            this.$router.push({
              name: "Aicourse",
              query: {
                buyCourseId: item.courseId,
                buyCollegeId: collegeId
              }
            });
          }
        });
      //-----------------■コースセット対応--------------------------------------
    },

    secondMenuChange: function(index1, id) {
      if (this.tagTwo == id) {
        return;
      }
      this.tagTwo = id;
      let allFlag = 1;
      if (id === -1) {
        this.tagTwo = this.courseInfo.courses[index1].id;
        allFlag = 1;
      } else {
        allFlag = 0;
      }
      this.tagOne = this.courseInfo.courses[index1].id;
      this.loading = true;
      this.companyId = window.sessionStorage.getItem("companyId");
      this.$api
        .post("/home/getHomeCourseInfoChild", {
          id: this.tagTwo,
          allFlag: allFlag,
          languageType: this.$lang()
        })
        .then(response => {
          this.courseInfo.courses[index1].courseList = response.data.courseList;
          let listCourse = this.courseInfo.courses[index1].courseList;
          let itemCourse = [];
          for (let index = 0; index < listCourse.length; index++) {
            const element = listCourse[index];
            if (index < 3) {
              itemCourse.push(element);
            }
          }

          itemCourse.forEach(el => {
            if (this.regex.test(el.synopsis)) {
              el["isUrl"] = true;
              let url = el.synopsis.split("\r\n");
              el.courseCover =
                "<iframe width='100% !important' height='100% !important' src='" +
                url[1] +
                "' frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>";
            } else {
              el["isUrl"] = false;
            }
          });
          this.listItemCourses = itemCourse;
          this.loading = false;
        });
    },
    mouseOverUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up oaa";
    },
    mouseLeaveUp($event) {
      $event.currentTarget.className = "el-icon-arrow-up up_laa";
    },
    mouseOverDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down oaa";
    },
    mouseLeaveDown($event) {
      $event.currentTarget.className = "el-icon-arrow-down down_laa";
    },
    checkLoginNameIsEmail(value){
      let regexMail = /(^\s*([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})\s*$)/;
      return regexMail.test(value); 
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nqt_disable {
  display: none;
}
.main {
  padding-top: 60px;
}

a {
  text-decoration: none;
  color: white;
  -webkit-tap-highlight-color: white;
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
}
.l {
  float: left;
}
.r {
  float: right;
}
.clear::after {
  content: ".";
  display: block;
  clear: both;
  height: 0;
  visibility: hidden;
}
.clear {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.container,
.bigCourse {
  width: 1200px;
  margin: 0 auto;
}
.swiper-container {
  width: 100%;
  height: 100%;
  margin-left: auto;
  margin-right: auto;
}
@media screen and (min-width: 1000px) and (max-width: 1200px) {
  .container,
  .bigCourse {
    width: 1000px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1000px) {
  .container,
  .bigCourse {
    width: 800px;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .container,
  .bigCourse {
    width: 600px;
  }
}
@media screen and (max-width: 600px) {
  .container,
  .bigCourse {
    width: 400px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
  }
  .swiper-slide img {
    display: block;
    width: 100%;
    height: 100px;
    object-fit: cover;
  }
}
.swiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.primarylists {
  padding-top: 10px;
}

.primarylists > ul > li {
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  padding-bottom: 50px;
  overflow: hidden;
}
.primarylists ul li .titles {
  height: 35px;
  width: 1000px; /* 需要配合JS动态设置宽度 */
  padding-bottom: 5px;
  color: black;
  margin-bottom: 10px;
  display: flex;
  inline-size: max-content;
}
.primarylists ul li .titles img {
  width: 32px;
  height: 32px;
  margin-top: 1px;
}
.primarylists ul li .titles .title {
  line-height: 16px !important;
  font-size: 20px;
  padding: 0 0px 0 10px;
  line-height: 35px;
  cursor: unset;
  font-weight: bold;
}
.primarylists ul li .titles .more {
  font-size: 16px;
  line-height: 35px;
  cursor: pointer;
  padding-right: 20px;
}
.primarylists ul li .titles .more a {
  color: black;
}
.primarylists ul li .titles .more :hover {
  color: #02adff;
}
.primarylists .secondlist {
  height: 100%;
  font-size: 16px;
}
.primarylists .secondlist ul li {
  float: left;
  padding: 3px 10px;
  cursor: pointer;
  margin-right: 16px;
  background: #666;
  border-radius: 15px;
  color: white;
}
.primarylists .secondlist ul li.choose {
  background: lightskyblue;
}

.primarylists .lessons ul {
  /* height: 350px; */
  height: auto;
  overflow: hidden;
  transform: translateX(5px);
}

.primarylists .lessons ul li {
  /* width: 190px;
  height: 170px; */
  width: 350px;
  height: auto;
  float: left;
  box-sizing: border-box;
  background: #333;
  background-clip: padding-box;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 20%) !important;
  border: #dadae8;
  cursor: pointer;
}
.primarylists .lessons ul li:hover {
  box-shadow: 0px 0px 20px 0px rgb(0 0 0 / 20%) !important;
}
/* .primarylists .lessons ul li:nth-of-type(1) {
  width: 390px;
  height: 350px;
}
.primarylists .lessons ul li:nth-of-type(1) .img {
  height: 200px;
} */
.primarylists .lessons ul li .img {
  height: 100px;
  width: 100%;
  overflow: hidden;
}
.primarylists .lessons ul li .img img {
  width: 100%;
  transition: all 0.25s ease-in-out;
  -moz-transition: all 0.25s ease-in-out;
  -webkit-transition: all 0.25s ease-in-out;
  -o-transition: all 0.25s ease-in-out;
}
.primarylists .lessons .lessontitle {
  padding: 0px 10px;
  margin: 8px 0 3px;
  color: #f8f8f8;
  font-size: 15px;
  cursor: pointer;
  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.primarylists .lessons .lessontitle:hover {
  color: #0071c5 !important;
}
.primarylists .lessons .introduce {
  padding: 0 10px;
  color: #999;
  font-size: 12px;

  /* 1行溢出隐藏 */
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.primarylists .lessons .islike {
  float: right;
  margin: 2px 10px 3px 0px;
  color: #f8f8f8;
  font-size: 10px;
  cursor: pointer;
  overflow: hidden;
}

.primarylists .lessons .islike span {
  float: right;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #02adff !important;
}
/* .primarylists .lessons ul li:nth-of-type(1) .lessontitle {
  font-size: 16px;
  padding: 15px 20px 0 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.primarylists .lessons ul li:nth-of-type(1) .introduce {
  font-size: 14px;
  line-height: 24px;
  padding: 10px 20px 0 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
} */

.footer {
  padding: 50px 0 30px 0;
  color: white;
  text-align: center;
  background: url(../../../static/images/bg/myCourseBackgroundFoot.jpg)
    no-repeat center bottom;
  background-size: cover;
}
.footer .line1 {
  font-size: 46px;
}
.footer .line2 {
  font-size: 14px;
  margin-bottom: 30px;
}
.footer .line3 {
  display: inline-block;
  padding: 5px 50px;
  border: 1px solid white;
  border-radius: 20px;
}
.footer .line3:hover {
  background: white;
  color: black;
  cursor: pointer;
}
.header {
  height: 60px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: #121212;
  color: white;
  z-index: 10;
  opacity: 0.8;
}
.header ul li {
  float: left;
  margin-right: 30px;
}
.header .logo {
  padding-top: 12px;
  cursor: pointer;
}
.header .logo img {
  height: 36px;
}
.header ul li div {
  height: 12px;
  font-size: 12px;
  position: relative;
}
.header ul li:hover div {
  color: #999;
}
.header ul li div span {
  height: 16px;
  width: 16px;
  line-height: 16px;
  text-align: center;
  background: red;
  color: white;
  display: block;
  border-radius: 50%;
  position: absolute;
  bottom: -8px;
  right: -18px;
}
.header ul li p {
  padding-top: 5px;
  font-size: 20px;
  text-align: center;
  color: #409eff;
}

.header .right {
  padding-top: 10px;
}
.header .right .user > div {
  margin-right: 10px;
}
.header .right .user .photo {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
}
.header .right .user .photo img {
  width: 100%;
}
.header .right .user .name,
.header .right .user .logout {
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .user .name:hover,
.header .right .user .logout:hover {
  color: #999;
}

.header .right .search {
  margin: 0 20px;
  font-size: 22px;
  height: 40px;
  line-height: 40px;
  cursor: pointer;
}
.header .right .search:hover {
  color: #999;
}
.header .right .flag {
  height: 40px;
  width: 60px;
  cursor: pointer;
  overflow: hidden;
  border-radius: 5px;
}
.header .right .flag img {
  width: 100%;
}
.swiper_bottom_shade {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 10;
  height: 200px;
  width: 100%;
  background: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(rgba(224, 224, 219, 0)),
    to(#fff)
  );
  background: -webkit-linear-gradient(top, rgba(224, 224, 219, 0), #fff 100%);
  background: linear-gradient(180deg, rgba(224, 224, 219, 0), #fff 100%);
}
.activemobile {
  height: 20px !important;
}
.bigCourse {
  position: relative;
}
.bigCourse ul {
  /*background-color: rgba(255,255,255,0.7);*/
  /*border-radius: 10px;*/
  /*padding: 30px 2% 0;*/
  width: 98%;
  margin: 0 1%;
  /*position: absolute;*/
  /*bottom: 10px;*/
  /*z-index: 9;*/
}

.bigCourse li a {
  font-size: 14px;
  background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
  background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
  padding: 5px 15px;
  border-radius: 5px;
  margin-right: 20px;
  float: left;
  margin-bottom: 10px;
}
.bigCourse li a:hover {
  background-image: -webkit-linear-gradient(315deg, #00d3ff 0%, #02adff 100%);
  background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
}
.showAllCourse {
  position: absolute;
  right: 10px;
  top: 5px;
  cursor: pointer;
}
.showAllCourse img {
  width: 19px;
}
/* .showAllCourse i{*/
/*  font-size: 20px;*/
/*   font-weight: bold;*/
/*   color: #666;*/
/*}*/
/*.showAllCourse i :hover{*/
/*  color: #02ADFF;*/
/*}*/
.primarymenu-add {
  height: 39px;
  overflow: hidden;
}
.boxout {
}
.boxout .boxin {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;
}
.boxout .boxin li.SchoolBusiness_menu_li {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none;
}

.el-tabs >>> .el-tabs__active-bar {
  height: 30px;
  background-color: #02adff;
  border-radius: 25px;
  padding: 0 20px;
  margin-left: -20px;
  margin-bottom: 5px;
}
.el-tabs >>> .el-tabs__item {
  z-index: 2;
}
.el-tabs >>> .el-tabs__nav-wrap:after {
  height: 0px;
  background-color: none;
}
.el-tabs >>> .el-tabs__nav-scroll {
  padding: 0 20px;
}
.el-tabs >>> .el-tabs__item.is-active {
  color: #fff;
}
.el-tabs >>> .toolbar {
  padding-top: 20px;
}
.el-tabs >>> .el-pager {
  margin: 0 10px;
}
.vaa :hover {
  transform: scale(1.05, 1.05);
  cursor: pointer;
}
.down_laa {
  -webkit-text-stroke-width: 2px;
  color: #999;
}
.up_laa {
  -webkit-text-stroke-width: 2px;
  color: #00d3ff;
}
.oaa {
  -webkit-text-stroke-width: 2px;
  color: #ffb821;
}
.target-fix {
  position: relative;
  top: -60px;
  display: block;
  height: 0;
  overflow: hidden;
}
.disabledCourse {
  display: none;
}
.like-ps {
  position: initial !important;
}
.primarylists .lessons .islike {
  float: left !important;
  color: #000 !important;
  background: none !important;
  box-shadow: none !important;
}
.vn .primarylists .lessons .islike span {
  color: #000 !important;
}
.lessontitle-under {
  height: 37px !important;
}
@media (max-width: 1112px) {
  .swiper-container {
    display: block !important;
  }
}
.swiper-button-prev:after,
.swiper-button-next:after {
  display: none;
}
.titles .title {
  padding: 0 0px 0 10px;
}
.title_more_catalog {
  float: right;
  display: flex;
}
.name_more_catalog {
  text-transform: none !important;
  cursor: pointer;
  font-size: 12px;
  color: #707070;
}
.swiper-button-next,
.swiper-button-prev {
  top: 8%;
}
.swiper-button-next {
  padding: 10.8% 7.4%;
  right: 0px;
}
.swiper-button-prev {
  padding: 10.8% 7.7%;
  left: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/index_vn.vue